var _excluded = ["children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { CopyOutlined, DeleteOutlined, DownOutlined, PlusOutlined, UpOutlined } from '@ant-design/icons';
import { RecordScope, RecordsScope, useField, useFieldSchema } from '@formily/react';
import { clone, isUndef, isValid } from '@formily/shared';
import { Button } from 'antd';
import cls from 'classnames';
import React, { createContext, useContext } from 'react';
import { useCssInJs, wrapReactionHook } from "../../hooks";
import getArrayBaseStyles from "./style";
export * from "./sort";
var ArrayBaseContext = /*#__PURE__*/createContext(null);
var ItemContext = /*#__PURE__*/createContext(null);
var takeRecord = function takeRecord(val, index) {
  return typeof val === 'function' ? val(index) : val;
};
var useArray = function useArray() {
  return useContext(ArrayBaseContext);
};
var useIndex = function useIndex(index) {
  var ctx = useContext(ItemContext);
  return (ctx ? ctx.index : index) || 0;
};
var useRecord = function useRecord(record) {
  var ctx = useContext(ItemContext);
  return takeRecord(ctx ? ctx.record : record, ctx === null || ctx === void 0 ? void 0 : ctx.index);
};
var getSchemaDefaultValue = function getSchemaDefaultValue(schema) {
  if ((schema === null || schema === void 0 ? void 0 : schema.type) === 'array') return [];
  if ((schema === null || schema === void 0 ? void 0 : schema.type) === 'object') return {};
  if ((schema === null || schema === void 0 ? void 0 : schema.type) === 'void') {
    for (var key in schema.properties) {
      var value = getSchemaDefaultValue(schema.properties[key]);
      if (isValid(value)) return value;
    }
  }
};
var getDefaultValue = function getDefaultValue(defaultValue, schema) {
  if (isValid(defaultValue)) return clone(defaultValue);
  if (Array.isArray(schema === null || schema === void 0 ? void 0 : schema.items)) return getSchemaDefaultValue(schema === null || schema === void 0 ? void 0 : schema.items[0]);
  return getSchemaDefaultValue(schema === null || schema === void 0 ? void 0 : schema.items);
};
var InternalArrayBase = wrapReactionHook(function (props) {
  var field = useField();
  var schema = useFieldSchema();
  return /*#__PURE__*/React.createElement(RecordsScope, {
    getRecords: function getRecords() {
      return field.value;
    }
  }, /*#__PURE__*/React.createElement(ArrayBaseContext.Provider, {
    value: {
      field: field,
      schema: schema,
      props: props
    }
  }, props.children));
});
var Item = wrapReactionHook(function (_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ItemContext.Provider, {
    value: props
  }, /*#__PURE__*/React.createElement(RecordScope, {
    getIndex: function getIndex() {
      return props.index;
    },
    getRecord: function getRecord() {
      return takeRecord(props.record, props.index);
    }
  }, children));
});

/* const InternalSortHandle = SortableHandle((props) => {
  const prefix = 'form-array-base'
  const { hashId, wrapSSR } = useCssInJs({ prefix, styleFun: getArrayBaseStyles, })

  return wrapSSR(
    <MenuOutlined
      {...props}
      className={cls(`${prefix}-sort-handle`, hashId, props.className)}
      style={{ ...props.style }}
    />
  )
}) */

var SortHandle = wrapReactionHook(function (props) {
  var _array$field;
  var array = useArray();
  if (!array) return null;
  if (((_array$field = array.field) === null || _array$field === void 0 ? void 0 : _array$field.pattern) !== 'editable') return null;
  return null;
});
var Index = wrapReactionHook(function (props) {
  var index = useIndex();
  var prefix = 'form-array-base';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: getArrayBaseStyles
    }),
    hashId = _useCssInJs.hashId,
    wrapSSR = _useCssInJs.wrapSSR;
  return wrapSSR( /*#__PURE__*/React.createElement("span", _extends({}, props, {
    className: cls("".concat(prefix, "-index"), hashId)
  }), "#", (index || 0) + 1, "."));
});
var Addition = wrapReactionHook(function (props) {
  var _array$field2, _array$field3;
  var self = useField();
  var array = useArray();
  var prefix = 'form-array-base';
  var _useCssInJs2 = useCssInJs({
      prefix: prefix,
      styleFun: getArrayBaseStyles
    }),
    hashId = _useCssInJs2.hashId,
    wrapSSR = _useCssInJs2.wrapSSR;
  if (!array) return null;
  if (((_array$field2 = array.field) === null || _array$field2 === void 0 ? void 0 : _array$field2.pattern) !== 'editable' && ((_array$field3 = array.field) === null || _array$field3 === void 0 ? void 0 : _array$field3.pattern) !== 'disabled') return null;
  return wrapSSR( /*#__PURE__*/React.createElement(Button, _extends({
    type: "dashed",
    block: true
  }, props, {
    disabled: self === null || self === void 0 ? void 0 : self.disabled,
    className: cls("".concat(prefix, "-addition"), hashId, props.className),
    onClick: function onClick(e) {
      var _array$props;
      if ((_array$props = array.props) !== null && _array$props !== void 0 && _array$props.disabled) return;
      var defaultValue = getDefaultValue(props.defaultValue, array.schema);
      if (props.method === 'unshift') {
        var _array$field4, _array$field4$unshift, _array$props2, _array$props2$onAdd;
        (_array$field4 = array.field) === null || _array$field4 === void 0 || (_array$field4$unshift = _array$field4.unshift) === null || _array$field4$unshift === void 0 || _array$field4$unshift.call(_array$field4, defaultValue);
        (_array$props2 = array.props) === null || _array$props2 === void 0 || (_array$props2$onAdd = _array$props2.onAdd) === null || _array$props2$onAdd === void 0 || _array$props2$onAdd.call(_array$props2, 0);
      } else {
        var _array$field5, _array$field5$push, _array$props3, _array$props3$onAdd, _array$field6;
        (_array$field5 = array.field) === null || _array$field5 === void 0 || (_array$field5$push = _array$field5.push) === null || _array$field5$push === void 0 || _array$field5$push.call(_array$field5, defaultValue);
        (_array$props3 = array.props) === null || _array$props3 === void 0 || (_array$props3$onAdd = _array$props3.onAdd) === null || _array$props3$onAdd === void 0 || _array$props3$onAdd.call(_array$props3, (array === null || array === void 0 || (_array$field6 = array.field) === null || _array$field6 === void 0 || (_array$field6 = _array$field6.value) === null || _array$field6 === void 0 ? void 0 : _array$field6.length) - 1);
      }
      if (props.onClick) {
        props.onClick(e);
      }
    },
    icon: isUndef(props.icon) ? /*#__PURE__*/React.createElement(PlusOutlined, null) : props.icon
  }), props.title || self.title));
});
var Copy = wrapReactionHook(function (props, ref) {
  var _array$field7;
  var self = useField();
  var array = useArray();
  var index = useIndex(props.index) || 0;
  var prefix = 'form-array-base';
  var _useCssInJs3 = useCssInJs({
      prefix: prefix,
      styleFun: getArrayBaseStyles
    }),
    hashId = _useCssInJs3.hashId,
    wrapSSR = _useCssInJs3.wrapSSR;
  if (!array) return null;
  if (((_array$field7 = array.field) === null || _array$field7 === void 0 ? void 0 : _array$field7.pattern) !== 'editable') return null;
  return wrapSSR( /*#__PURE__*/React.createElement(Button, _extends({
    ghost: true
  }, props, {
    style: props.style,
    disabled: self === null || self === void 0 ? void 0 : self.disabled,
    className: cls("".concat(prefix, "-copy"), hashId, self !== null && self !== void 0 && self.disabled ? "".concat(prefix, "-copy-disabled") : '', props.className),
    ref: ref,
    onClick: function onClick(e) {
      var _array$props4, _array$field8, _array$field9, _array$field9$insert, _array$props5, _array$props5$onCopy;
      if (self !== null && self !== void 0 && self.disabled) return;
      e.stopPropagation();
      if ((_array$props4 = array.props) !== null && _array$props4 !== void 0 && _array$props4.disabled) return;
      if (props.onClick) {
        props.onClick(e);
        if (e.defaultPrevented) return;
      }
      var value = clone(array === null || array === void 0 || (_array$field8 = array.field) === null || _array$field8 === void 0 ? void 0 : _array$field8.value[index]);
      var distIndex = index + 1;
      (_array$field9 = array.field) === null || _array$field9 === void 0 || (_array$field9$insert = _array$field9.insert) === null || _array$field9$insert === void 0 || _array$field9$insert.call(_array$field9, distIndex, value);
      (_array$props5 = array.props) === null || _array$props5 === void 0 || (_array$props5$onCopy = _array$props5.onCopy) === null || _array$props5$onCopy === void 0 || _array$props5$onCopy.call(_array$props5, distIndex);
    },
    icon: isUndef(props.icon) ? /*#__PURE__*/React.createElement(CopyOutlined, null) : props.icon
  }), props.title || self.title));
}, {
  forwardRef: true
});
var Remove = wrapReactionHook(function (props, ref) {
  var _array$field10;
  var index = useIndex(props.index);
  var self = useField();
  var array = useArray();
  var prefix = 'form-array-base';
  var _useCssInJs4 = useCssInJs({
      prefix: prefix,
      styleFun: getArrayBaseStyles
    }),
    hashId = _useCssInJs4.hashId,
    wrapSSR = _useCssInJs4.wrapSSR;
  if (!array) return null;
  if (((_array$field10 = array.field) === null || _array$field10 === void 0 ? void 0 : _array$field10.pattern) !== 'editable') return null;
  return wrapSSR( /*#__PURE__*/React.createElement(Button, _extends({
    ghost: true
  }, props, {
    style: props.style,
    disabled: self === null || self === void 0 ? void 0 : self.disabled,
    className: cls("".concat(prefix, "-remove"), hashId, self !== null && self !== void 0 && self.disabled ? "".concat(prefix, "-remove-disabled") : '', props.className),
    ref: ref,
    onClick: function onClick(e) {
      var _array$field11, _array$field11$remove, _array$props6, _array$props6$onRemov;
      if (self !== null && self !== void 0 && self.disabled) return;
      e.stopPropagation();
      if (props.onClick) {
        props.onClick(e);
        if (e.defaultPrevented) return;
      }
      (_array$field11 = array.field) === null || _array$field11 === void 0 || (_array$field11$remove = _array$field11.remove) === null || _array$field11$remove === void 0 || _array$field11$remove.call(_array$field11, index);
      (_array$props6 = array.props) === null || _array$props6 === void 0 || (_array$props6$onRemov = _array$props6.onRemove) === null || _array$props6$onRemov === void 0 || _array$props6$onRemov.call(_array$props6, index);
    },
    icon: isUndef(props.icon) ? /*#__PURE__*/React.createElement(DeleteOutlined, null) : props.icon
  }), props.title || self.title));
}, {
  forwardRef: true
});
var MoveDown = wrapReactionHook(function (props, ref) {
  var _array$field12;
  var index = useIndex(props.index);
  var self = useField();
  var array = useArray();
  var prefix = 'form-array-base';
  var _useCssInJs5 = useCssInJs({
      prefix: prefix,
      styleFun: getArrayBaseStyles
    }),
    wrapSSR = _useCssInJs5.wrapSSR,
    hashId = _useCssInJs5.hashId;
  if (!array) return null;
  if (((_array$field12 = array.field) === null || _array$field12 === void 0 ? void 0 : _array$field12.pattern) !== 'editable') return null;
  return wrapSSR( /*#__PURE__*/React.createElement(Button, _extends({
    ghost: true
  }, props, {
    style: props.style,
    disabled: self === null || self === void 0 ? void 0 : self.disabled,
    className: cls("".concat(prefix, "-move-down"), self !== null && self !== void 0 && self.disabled ? "".concat(prefix, "-move-down-disabled") : '', props.className),
    ref: ref,
    onClick: function onClick(e) {
      var _array$field13, _array$field13$moveDo, _array$props7, _array$props7$onMoveD;
      if (self !== null && self !== void 0 && self.disabled) return;
      e.stopPropagation();
      if (props.onClick) {
        props.onClick(e);
        if (e.defaultPrevented) return;
      }
      (_array$field13 = array.field) === null || _array$field13 === void 0 || (_array$field13$moveDo = _array$field13.moveDown) === null || _array$field13$moveDo === void 0 || _array$field13$moveDo.call(_array$field13, index);
      (_array$props7 = array.props) === null || _array$props7 === void 0 || (_array$props7$onMoveD = _array$props7.onMoveDown) === null || _array$props7$onMoveD === void 0 || _array$props7$onMoveD.call(_array$props7, index);
    },
    icon: isUndef(props.icon) ? /*#__PURE__*/React.createElement(DownOutlined, null) : props.icon
  }), props.title || self.title));
}, {
  forwardRef: true
});
var MoveUp = wrapReactionHook(function (props, ref) {
  var _array$field14;
  var index = useIndex(props.index);
  var self = useField();
  var array = useArray();
  var prefix = 'form-array-base';
  var _useCssInJs6 = useCssInJs({
      prefix: prefix,
      styleFun: getArrayBaseStyles
    }),
    wrapSSR = _useCssInJs6.wrapSSR,
    hashId = _useCssInJs6.hashId;
  if (!array) return null;
  if (((_array$field14 = array.field) === null || _array$field14 === void 0 ? void 0 : _array$field14.pattern) !== 'editable') return null;
  return wrapSSR( /*#__PURE__*/React.createElement(Button, _extends({
    ghost: true
  }, props, {
    style: props.style,
    disabled: self === null || self === void 0 ? void 0 : self.disabled,
    className: cls("".concat(prefix, "-move-up"), self !== null && self !== void 0 && self.disabled ? "".concat(prefix, "-move-up-disabled") : '', props.className),
    ref: ref,
    onClick: function onClick(e) {
      var _array$field15, _array$props8, _array$props8$onMoveU;
      if (self !== null && self !== void 0 && self.disabled) return;
      e.stopPropagation();
      if (props.onClick) {
        props.onClick(e);
        if (e.defaultPrevented) return;
      }
      array === null || array === void 0 || (_array$field15 = array.field) === null || _array$field15 === void 0 || _array$field15.moveUp(index);
      array === null || array === void 0 || (_array$props8 = array.props) === null || _array$props8 === void 0 || (_array$props8$onMoveU = _array$props8.onMoveUp) === null || _array$props8$onMoveU === void 0 || _array$props8$onMoveU.call(_array$props8, index);
    },
    icon: isUndef(props.icon) ? /*#__PURE__*/React.createElement(UpOutlined, null) : props.icon
  }), props.title || self.title));
}, {
  forwardRef: true
});
function mixin(target) {
  return Object.assign(target, {
    Index: Index,
    SortHandle: SortHandle,
    Addition: Addition,
    Copy: Copy,
    Remove: Remove,
    MoveDown: MoveDown,
    MoveUp: MoveUp,
    useArray: useArray,
    useIndex: useIndex,
    useRecord: useRecord
  });
}
export var ArrayBase = Object.assign(InternalArrayBase, {
  Item: Item,
  Index: Index,
  SortHandle: SortHandle,
  Addition: Addition,
  Copy: Copy,
  Remove: Remove,
  MoveDown: MoveDown,
  MoveUp: MoveUp,
  useArray: useArray,
  useIndex: useIndex,
  useRecord: useRecord,
  mixin: mixin
});
export default ArrayBase;